"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  validValuesHeader: {
    id: 'ValidValuesHeader.validValuesHeader',
    defaultMessage: '{attribute} allows the following valid values and ranges:'
  }
});

exports["default"] = _default;